import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import NoData from "../../Pages/NoData";

// Shimmer Loading Component
const ClientShimmer = () => {
    return (
        <Container>
            <div className="pb-5">
                <Row
                    className="rounded-4 overflow-hidden d-flex align-items-stretch"
                    style={{ margin: "60px 0px 80px" }}
                >
                    {[1, 2, 3, 4].map((item, i) => (
                        <Col xs={12} lg={6} key={i} className="p-3 mb-5 d-flex">
                            <div className="rounded-4 overflow-hidden shadow-sm position-relative w-100 d-flex flex-column">
                                {/* Image shimmer */}
                                <div className="w-100 overflow-hidden position-relative custom-height-client">
                                    <div
                                        className="w-100 h-100 shimmer"
                                        style={{
                                            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                            backgroundSize: "200% 100%",
                                            animation: "shimmer 1.5s infinite"
                                        }}
                                    ></div>
                                </div>

                                {/* Text section shimmer */}
                                <div className="p-4 bg-white flex-grow-1 d-flex flex-column">
                                    <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-2 mb-3">
                                        {/* Title shimmer */}
                                        <div
                                            className="shimmer rounded mb-2 flex-grow-1"
                                            style={{
                                                height: "24px",
                                                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                                backgroundSize: "200% 100%",
                                                animation: "shimmer 1.5s infinite"
                                            }}
                                        ></div>

                                        {/* Badge shimmer */}
                                        <div
                                            className="shimmer rounded-2"
                                            style={{
                                                width: "120px",
                                                height: "28px",
                                                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                                backgroundSize: "200% 100%",
                                                animation: "shimmer 1.5s infinite"
                                            }}
                                        ></div>
                                    </div>

                                    {/* Description shimmer lines */}
                                    <div className="flex-grow-1 pt-2">
                                        <div
                                            className="shimmer rounded mb-2"
                                            style={{
                                                height: "16px",
                                                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                                backgroundSize: "200% 100%",
                                                animation: "shimmer 1.5s infinite"
                                            }}
                                        ></div>
                                        <div
                                            className="shimmer rounded mb-2"
                                            style={{
                                                height: "16px",
                                                width: "80%",
                                                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                                backgroundSize: "200% 100%",
                                                animation: "shimmer 1.5s infinite"
                                            }}
                                        ></div>
                                        <div
                                            className="shimmer rounded"
                                            style={{
                                                height: "16px",
                                                width: "60%",
                                                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                                backgroundSize: "200% 100%",
                                                animation: "shimmer 1.5s infinite"
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Shimmer animation styles */}
            <style jsx>{`
                @keyframes shimmer {
                    0% {
                        background-position: -200% 0;
                    }
                    100% {
                        background-position: 200% 0;
                    }
                }
                .shimmer {
                    animation: shimmer 1.5s ease-in-out infinite;
                }
            `}</style>
        </Container>
    );
};

const Client = ({ portfolio, loading = false }) => {
    
    if (loading) {
        return <ClientShimmer />;
    }

    // Filter client data first
    const clientData = portfolio && Array.isArray(portfolio) 
        ? portfolio.filter(item => item.type === "client") 
        : [];

    // If no portfolio data or no client data after filtering, show NoData
    if (!portfolio || !Array.isArray(portfolio) || clientData.length === 0) {
        return <NoData />;
    }

    const handleCardClick = (link) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    return (
        <div>
            <Container>
                <div className="pb-5">
                    <Row
                        className="rounded-4 overflow-hidden d-flex align-items-stretch"
                        style={{ margin: "60px 0px 80px" }}
                    >
                        {clientData.map((item, i) => (
                            <Col xs={12} lg={6} key={i} className="p-3 mb-5 d-flex">
                                <div 
                                    className="rounded-4 overflow-hidden shadow-sm position-relative group w-100 d-flex flex-column clickable-card"
                                    onClick={() => handleCardClick(item.link)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleCardClick(item.link);
                                        }
                                    }}
                                >
                                    {/* Image container */}
                                    <div className="w-100 overflow-hidden position-relative custom-height-client">
                                        <img
                                            src={item.image[0]}
                                            alt={item.title}
                                            className="w-100 h-100"
                                            style={{
                                                objectFit: "cover",
                                                transition: "transform 0.5s ease",
                                            }}
                                        />

                                        {/* Black transparent overlay */}
                                        {/* <div
                                            className="position-absolute top-0 start-0 w-100 h-100 overlay"
                                            style={{
                                                background: "rgba(0,0,0,0.4)",
                                                opacity: 0,
                                                transition: "opacity 0.4s ease",
                                            }}
                                        ></div> */}

                                        {/* Hover overlay button */}
                                        {/* <div
                                            className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle d-flex align-items-center justify-content-center arrow-button"
                                            style={{
                                                width: "50PX",
                                                height: "50PX",
                                                opacity: 0,
                                                transition: "opacity 0.4s ease",
                                                textDecoration: "none",
                                                pointerEvents: "none", // Prevent this from interfering with card click
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faLink} className="fs-6 text-black hover:text-primary" />
                                        </div> */}
                                    </div>

                                    {/* Text section - flex-grow-1 ensures it takes remaining space */}
                                    <div className="p-4 bg-white flex-grow-1 d-flex flex-column">
                                        <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-2 mb-3">
                                            <h4
                                                className="mb-0 flex-grow-1"
                                                style={{
                                                    color: "#091045",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                {item.title}
                                            </h4>

                                            <div
                                                className="text-blue rounded-2 px-2 py-1 visit-link"
                                                style={{
                                                    fontSize: "15px",
                                                    whiteSpace: "nowrap",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                Visit Website <FontAwesomeIcon icon={faArrowRight} className="ps-2"/>
                                            </div>
                                        </div>

                                        <p className="flex-grow-1 mb-0 pt-2" style={{ color: "#4c5663", fontSize: "15px" }}>
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>

            {/* CSS for hover effects */}
            <style jsx>{`
                .clickable-card {
                    cursor: pointer;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .clickable-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 15px rgba(0,0,0,0.15) !important;
                }
                .clickable-card:focus {
                    outline-offset: 2px;
                }
                .group:hover img {
                    transform: scale(1.05);
                }
                .group:hover .arrow-button {
                    opacity: 1 !important;
                }
                .group:hover .overlay {
                    opacity: 1 !important;
                }
                /* Visit Website link hover color */
                .clickable-card:hover .visit-link {
                    color: #0777AB !important;
                    transition: color 0.3s ease;
                }
            `}</style>
        </div>
    );
};

export default Client;